import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import UniversalHeader from '@/components/shared/UniversalHeader'
import UniversalFooter from '@/components/shared/UniversalFooter'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar'
import { useAuth } from '@/context/auth-context'

export default function AppLayout() {
  const { user } = useAuth()
  const [sidebarOpen, setSidebarOpen] = useState(true)

  return (
    <div className="min-h-screen bg-background">
      {/* Dashboard Sidebar for all authenticated users */}
      {user && <DashboardSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />}

      {/* Header - full width including sidebar */}
      <div className="fixed top-0 left-0 right-0 z-40">
        <UniversalHeader />
      </div>

      {/* Main Content Area with top padding for header */}
      <div className={`transition-all duration-300 pt-24 ${user ? (sidebarOpen ? 'ml-64' : 'ml-20') : ''} flex flex-col min-h-screen`}>
        {/* Page Content */}
        <div
          className={`flex-1 ${user ? 'px-6 py-6 rounded-tl-3xl' : 'container mx-auto px-4 py-8'
            } bg-slate-50 text-slate-800`}
        >
          <div className="animate-fade-in-up">
            <Outlet />
          </div>
        </div>

        {/* Footer */}
        <div className="bg-[#0F172A] mt-auto">
          <UniversalFooter />
        </div>
      </div>
    </div>
  )
}